import { render, staticRenderFns } from "./TabRealShipmentNew.vue?vue&type=template&id=5d5d790b&scoped=true"
import script from "./TabRealShipmentNew.vue?vue&type=script&lang=js"
export * from "./TabRealShipmentNew.vue?vue&type=script&lang=js"
import style0 from "./TabRealShipmentNew.vue?vue&type=style&index=0&id=5d5d790b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d790b",
  null
  
)

export default component.exports